import React from 'react';
import moment from 'moment';
import useStyles from './styles';
import { Invoice } from '../../../types/items';
import { Link } from '../../../components';
import { toMoneyFormat } from '../../../utility/string';

type Props = {
  invoices: Invoice[];
};

const InvoicesTable = ({ invoices }: Props) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.label}>Invoice History</div>

      <div className={classes.table}>
        {(invoices && invoices.length)
          ? invoices.map((invoice) => (
            <React.Fragment key={invoice.id}>
              <div className={classes.tableItem}>{moment(invoice.created * 1000).format('MMMM DD, YYYY')}</div>
              <div className={`${classes.amount} ${classes.tableItem}`}>
                {toMoneyFormat(invoice.currency, invoice.amount_due)}
              </div>
              <div className={classes.tableItem}>
                {
                  invoice.invoice_pdf
                  && (
                    <Link
                      disabled={!invoice.invoice_pdf}
                      onClick={() => { window.location.href = invoice.invoice_pdf; }}
                    >
                      Download Invoice
                    </Link>
                  )
                }
              </div>
              <div className={classes.tableItem}>
                {
                  invoice.receipt_url
                  && (
                    <Link
                      target="_blank"
                      onClick={() => { window.open(invoice.receipt_url, '_blank'); }}
                      disabled={!invoice.receipt_url}
                    >
                      View Receipt
                    </Link>
                  )
                }

              </div>
            </React.Fragment>
          ))
          : <div>No Data</div>}
      </div>
    </div>
  );
};

export default InvoicesTable;
